import { InputLabel, MenuItem, SelectChangeEvent, Theme } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from '../pmi-select';
import { PmiFormControl } from '../pmi-select/pmi-form-control';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    label: {
      color: `${theme.palette.cdmBrandOrange.main} !important`,
    },
    root: {
      '& .MuiSelect-iconOutlined': {
        color: `${theme.palette.cdmBrandOrange.main} !important`,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: `${theme.palette.cdmBrandOrange.main} !important`,
        color: `${theme.palette.cdmBrandOrange.main} !important`,
        '&.Mui-disabled': {
          borderColor: `${theme.palette.cdmBrandOrange.main} !important`,
        },
      },
    },
  });
});

const list = Object.freeze([
  {
    id: '1',
    value: 'V',
  },
  {
    id: '9',
    value: 'N',
  },
]);

interface ListFiscalCodeIDProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  isConflicting?: boolean;
}

const ListFiscalCodeIDComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isConflicting = false,
}: ListFiscalCodeIDProps): React.ReactElement => {
  const classes = useStyles();

  return (
    <PmiFormControl fullWidth>
      <InputLabel
        className={isConflicting ? classes.label : undefined}
        error={error}
        disabled={disabled}
        id="item-label"
      >
        {required ? 'Stato CF *' : 'Stato CF'}
      </InputLabel>
      <PmiSelect
        labelId="item-label"
        id="item"
        name="item"
        value={value}
        className={isConflicting ? classes.root : undefined}
        SelectDisplayProps={{
          className: isConflicting ? classes.root : undefined,
        }}
        disabled={disabled}
        label={required ? 'Stato CF *' : 'Stato CF'}
        onChange={onChange}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListFiscalCodeIDComponent.displayName = 'List Fiscal Code ID component';

const ListFiscalCodeID = memo(ListFiscalCodeIDComponent);

export default ListFiscalCodeID as typeof ListFiscalCodeIDComponent;
